import "core-js/stable";
import React from "react";
import ReactDOM from "react-dom";
import App from "./frame/components/app";
import * as serviceWorker from "./service-worker";
import "typeface-roboto";
import "./index.css";
import { store } from "./frame/components/configure-store";
import { UpdateAvailable } from "./features/notifications/actions/update-actions";
import {
	ensureProductionClientIsCurrent,
	prepareDevelopmentClient,
	registerServiceWorkerReloadOnActivate,
} from "./client-bootstrap";

// Deploy marker so the next live build records a new git SHA.
const initializeAppVersion = () => {
	const gitSha = process.env.REACT_APP_GIT_SHA;
	const version = gitSha || "dev";
	localStorage.setItem("app_version", version);
	console.log("App version initialized:", version);
};

registerServiceWorkerReloadOnActivate();

const render = (Component) => {
	ReactDOM.render(<Component />, document.getElementById("root"));
};

const boot = async () => {
	initializeAppVersion();

	// Remove stale production service workers before React mounts (avoids update errors on localhost).
	if (process.env.NODE_ENV === "development") {
		await prepareDevelopmentClient();
	}

	render(App);

	if (process.env.NODE_ENV === "production") {
		ensureProductionClientIsCurrent().catch((error) => {
			console.warn("App version check failed:", error);
		});

		if ("serviceWorker" in navigator && navigator.onLine !== false) {
			navigator.serviceWorker.getRegistrations().then((registrations) => {
				registrations.forEach((registration) => {
					registration.update().catch((error) => {
						console.warn("Service worker update check failed:", error);
					});
				});
			});
		}
	}
};

boot();

if (module.hot) {
	module.hot.accept("./frame/components/app", () => {
		const NextApp = require("./frame/components/app").default;
		render(NextApp);
	});
}

serviceWorker.register({
	onUpdate: (registration) => {
		// Notify the user; apply only when they confirm (avoids A/B reload loops with
		// version-check unregister + controllerchange). Waiting worker activates via update-effect.
		if (registration.waiting) {
			// Keep a reference so the update UI can activate this worker.
			window.__ftrWaitingServiceWorker = registration.waiting;
		}
		store.dispatch(UpdateAvailable());
	},
});
